'use strict';
const filterModule = angular.module('tdl.filters', []);

export default  filterModule;
